/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ImageResource { 
    target: string;
    thumb: string;
    index: string;
    width: string;
    height: string;
    title: string;
    portrait: string;
    link: string;
}

